export default class Header {
  constructor(component) {
    this.dom = {
      $component: component,
      $body: document.querySelector('body'),
      $navigation: component.querySelector('.js-navigation'),
      $headerSpacer: document.querySelector('.js-headerSpacer'),
      $promoBar: component.querySelector('.js-promobar'),
      $countdownTimerElement: document.querySelector('.js-countdown'),
      $timeElement: document.querySelector('.js-countdown-time'),
    }
    this.state = {
      hidePromoClass: 'hidePromo',
      navScrolledClass: 'navScrolled',
      promoHidden: 'promoHidden',
      height: 0,
      isInitialised: false,
    }
    this.navScrollHandler = this.navScroll.bind(this)

    this.mount()
    this.bindToWindow()
    this.initCountdownTimer()
  }

  mount() {
    const { dom } = this
    const { lockPromobar } = dom.$promoBar.dataset

    this.getHeaderHeight()

    if (lockPromobar === 'true') {
      return
    }

    window.addEventListener('scroll', this.navScrollHandler)
    window.addEventListener('resize', this.getHeaderHeight.bind(this))
  }

  navScroll() {
    const { dom, state } = this
    if (window.pageYOffset > 50) {
      dom.$navigation.classList.add(state.navScrolledClass)
      dom.$body.classList.add(state.promoHidden)

      if (dom.$promoBar) {
        dom.$promoBar.classList.add(state.hidePromoClass)
        dom.$headerSpacer.classList.add(state.hidePromoClass)
      }
    } else {
      dom.$navigation.classList.remove(state.navScrolledClass)
      dom.$body.classList.remove(state.promoHidden)

      if (dom.$promoBar) {
        dom.$promoBar.classList.remove(state.hidePromoClass)
        dom.$headerSpacer.classList.remove(state.hidePromoClass)
      }
    }
  }

  getHeaderHeight() {
    const { dom, state } = this
    state.height = dom.$component.offsetHeight

    document.documentElement.style.setProperty(
      '--header-height',
      `${state.height}px`,
    )
  }

  initCountdownTimer() {
    const { $countdownTimerElement } = this.dom
    if (!$countdownTimerElement) {
      this.setDefaultOffsets()
      return
    }

    const daysLabel = $countdownTimerElement.dataset.days
    const hoursLabel = $countdownTimerElement.dataset.hours
    const minutesLabel = $countdownTimerElement.dataset.minutes
    const secondsLabel = $countdownTimerElement.dataset.seconds
    const countdownEndTimeStr = $countdownTimerElement.dataset.end

    const countdownEndTime = new Date(countdownEndTimeStr.replace(/-/g, '/'))
    const estOffset = -5 * 60
    const countdownEndTimeEST = new Date(
      countdownEndTime.getTime(),
    )

    const updateCountdown = () => {
      const now = new Date()
      const nowEST = new Date(
        now.getTime() +
        ((now.getTimezoneOffset() + estOffset) * 60000),
      )
      const timeRemaining = countdownEndTimeEST - nowEST

      if (timeRemaining > 0) {
        const { $timeElement } = this.dom

        if (!$timeElement) {
          return
        }

        $countdownTimerElement.style.display = 'flex'
        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24))
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000)

        $timeElement.innerText = `${days} ${daysLabel} ${hours} ${hoursLabel} ${minutes} ${minutesLabel} ${seconds} ${secondsLabel}`

        if (!this.state.isInitialised) {
          this.setCountdownOffsets()
          this.state.isInitialised = true
        }

      } else {
        $countdownTimerElement.style.display = 'none'
        this.setDefaultOffsets()
        this.state.isInitialised = false
      }
    }

    // Update the countdown timer every second
    setInterval(updateCountdown, 1000)
    updateCountdown()

  }

  setDefaultOffsets() {
    document.documentElement.style.setProperty('--desktop-header-offset', '84px')
    document.documentElement.style.setProperty('--desktop-header-collapsed-offset', '48px')

    document.documentElement.style.setProperty('--mobile-header-offset', '84px')
    document.documentElement.style.setProperty('--mobile-header-collapsed-offset', '47px')
  }

  setCountdownOffsets() {
    document.documentElement.style.setProperty('--desktop-header-offset', '120px')
    document.documentElement.style.setProperty('--desktop-header-collapsed-offset', '84px')

    document.documentElement.style.setProperty('--mobile-header-offset', '144px')
    document.documentElement.style.setProperty('--mobile-header-collapsed-offset', '107px')
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.Header = this
  }
}
